<template>
  <c-dialog
    v-bind="$attrs"
    width="80%"
    top="3vh"
    max-height="65vh"
    title="筛选项管理"
    :before-close="closeDialog"
  >
    <el-table
      :data="filterList"
      border
      height="400"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="label"
        width="300"
      >
        <template slot="header">
          <span>筛选项名称</span>
          <el-button class="reset-button" size="mini" type="danger" plain @click="handleReset"><i class="el-icon-refresh-left" />还原预设</el-button>
        </template>
        <template v-slot="{row}">
          <el-input
            v-model="row.label"
            size="mini"
            placeholder="筛选项名称"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="rules"
        label="筛选关键词 (请务必用英文逗号','分隔,如: 遗愿,一愿,佩特拉,如果使用中文逗号会导致筛选项无法使用)"
      >
        <template v-slot="{row}">
          <el-input
            v-model="row.rules"
            size="mini"
            placeholder="筛选关键词"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        width="80"
      >
        <template v-slot="{row}">
          <i class="el-icon-delete" style="color: red" @click="handleDelete(row)" />
        </template>
      </el-table-column>
    </el-table>
    <el-button plain class="add-button" icon="el-icon-plus" @click="addFilter">新增筛选</el-button>
    <template slot="footer">
      <el-button size="small" type="primary" class="g-dialog-footerBtn-OK" @click="handleFilter">保存</el-button>
      <el-button size="small" class="g-dialog-footerBtn-NO" @click="closeDialog()">取消</el-button>
    </template>
  </c-dialog>
</template>

<script>

import { getKeyWords, setKeyWords, initKeyWords } from '@/utils/keywords'

export default {
  name: 'FilterManagement',
  data() {
    return {
      filterList: [],
      multipleSelection: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    init() {
      this.filterList = getKeyWords()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    addFilter() {
      this.filterList.push({
        label: '',
        rules: ''
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将删除该筛选项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.filterList.splice(this.filterList.indexOf(row), 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleFilter() {
      setKeyWords(this.filterList)
      this.$emit('update-change')
      this.$nextTick(() => {
        this.closeDialog()
      })
    },
    closeDialog() {
      this.visible = false
    },
    handleReset() {
      this.$confirm('此操作将还原预设筛选项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.filterList = initKeyWords()
        this.$message({
          type: 'success',
          message: '还原成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消还原'
        })
      })
    }
  }
}
</script>

<style scoped>
.add-button{
  margin-top: 10px;
  width:100%;
  text-align: center;
}
.reset-button{
  margin-left: 10px;
}
</style>
